import { Aspect, AspectCollection } from '@lib.core/entities/indicator/indicator';
import { AspectRanking } from '@lib.core/entities/indicator/indicator-ranking';
import { MetadataCompleteDTO } from '@lib.resources/indicator/dtos/metadata-complete';
import { AspectSummaryDTO } from '@lib.resources/indicator/dtos/indicator-summary';
import { AspectContextDTO } from '@lib.resources/indicator/dtos/indicator-context';
import { AspectDatapointDTO } from '@lib.resources/indicator/dtos/indicator-data';
import { PagedDTO } from '@lib.resources/utils/paged';

export type AspectCollectionDTO = PagedDTO<AspectDTO>;

export interface AspectDTO {
  aspectHashKey: string;
  aspectNameid?: string;
  context?: AspectContextDTO;
  aspectSummary: AspectSummaryDTO;
  snapshotId?: string;
  metaData?: MetadataCompleteDTO;
  data?: AspectDatapointDTO[];
  ranking?: AspectRanking;
}

export function newAspectCollectionFromDto(aspectCollectionDTO: AspectCollectionDTO): AspectCollection {
  const { items, total, pageSize, currentPage } = aspectCollectionDTO;
  return {
    aspectInstances: items.map(aspect => newAspectFromDto(aspect)),
    total,
    pageSize,
    currentPage,
  };
}

export function newAspectFromDto(aspectDTO: AspectDTO): Aspect {
  return {
    ...aspectDTO,
    aspectNameId: aspectDTO.aspectNameid,
    data: aspectDTO.data?.map(dp => AspectDatapointDTO.toAspectDatapoint(dp)),
    aspectSummary: AspectSummaryDTO.toAspectSummary(
      aspectDTO.aspectSummary
    ),
    context: aspectDTO.context ? AspectContextDTO.toAspectContext(aspectDTO.context) : undefined,
  };
}
